export const FONT_CATEGORIES = [
  "sans-serif",
  "serif",
  "display",
  "handwriting",
  "monospace",
] as const;

export type GoogleFont = {
  family: string;
  category: (typeof FONT_CATEGORIES)[number];
  // The upright weights the family has.
  weights: number[];
};

// The stylesheet that loads the fonts from Google Fonts. With `text`, each
// family has only the glyphs of that text, which is enough to show a sample.
export function googleFontsUrl(fonts: GoogleFont[], text?: string): string {
  const url = new URL("https://fonts.googleapis.com/css2");
  for (const { family, weights } of fonts) {
    url.searchParams.append("family", text ? family : `${family}:wght@${weights.join(";")}`);
  }
  if (text) url.searchParams.set("text", text);
  url.searchParams.set("display", "swap");
  return url.toString();
}
